<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="ProductTags">
        <template v-slot:PageBody>

          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_ProductInfo_Memu_ProductTags')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_ProductInfo_ProductTags_Blue_p')">
                </div>
              </template>
            </BasicPageTop>
            <div>

              <div class="row" v-if="AplusABCBasicBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_HotSearchTag') }}
                  </div>
                </div>
                <div class="col-12" id="Div_HotSearchTag">
                  <div class="form-group form-10-bottom-margin" style="margin-bottom: 10px !important">
                    <multiselection id="HotSearchTag" v-model="form.tagList" label="label" track-by="id" :MaxLength="GetSearchTagNums"
                      :options="SelectOptions.TagsOptions" :multiple="true" :taggable="true"
                      :title="$t('lbl_EMPBE_ProductInfo_PleaseSelectMax1',{nums:GetSearchTagNums})">
                    </multiselection>
                  </div>
                </div>
              </div>

              <div class="row" v-if="AplusABCBasicBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_FeaturedProduct') }}
                  </div>
                </div>
                <div class="col-12 LeadTime">
                  {{ $t('lbl_EMPBE_ProductInfo_prioritizedForDisplay') }}
                </div>
                <div class="col-12" style="margin-bottom: 1rem;">
                  <switchIput class="mt-2" ControlId="isMainProduct" :left="$t('lbl_EMPBE_Yes')"
                    style="margin-bottom: 0px;" :right="$t('lbl_EMPBE_No')" v-model="form.formData.isMainProduct">
                  </switchIput>
                  <div class="errorTips" v-if="IsShowMainProductErrorTips">{{$t('lbl_EMPBE_ProductInfoIsMainError')}}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_launchProduct') }}
                  </div>
                </div>
                <div class="col-12" id="div_launchProduct">
                  <datePicker_cp :title="$t('lbl_EMPBE_ProductInfo_launchProduct_PlaceOther')"
                    input-class="datepicker-here form-control digits" v-model="form.formData.premiereDate"
                    :dateTimeFormat="'yyyy-MM-dd'" data-item="premiereDate">
                  </datePicker_cp>
                </div>
              </div>


              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_WhichMarket') }}
                  </div>
                </div>
                <div class="col-12">
                  <selection ControlId="newTech" class="w-100"
                    :title="$t('lbl_EMPBE_ProductInfo_WhichMarket_PlaceOther')" v-model="form.formData.newTech"
                    :options="SelectOptions.NewsOptions">
                  </selection>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_provideProduct') }}
                  </div>
                </div>
                <div class="col-12">
                  <switchIput class="mt-2" ControlId="isProvideFreeSample" :left="$t('lbl_EMPBE_ProductInfo_Will')"
                    :right="$t('lbl_EMPBE_ProductInfo_WillNot')" v-model="form.formData.isProvideFreeSample">
                  </switchIput>
                </div>
              </div>

              <!-- CPS2026 现场展示已隐藏；GetData/保存仍回写 temp_Company_Property 历史值 -->
              <div class="row" v-if="false">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_isShowProductCPS2026') }}
                  </div>
                </div>
                <div class="col-12">
                  <switchIput class="mt-2" ControlId="isShowProductCPS2026" :left="$t('lbl_EMPBE_ProductInfo_Yes')"
                    :right="$t('lbl_EMPBE_ProductInfo_No')" v-model="form.formData.isShowProductCPS2026">
                  </switchIput>
                </div>
              </div>
              <div class="row" >
                <div class="col-12 mb-2 Input_Label" style="display: grid;gap: 8px;">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_Customization') }}&nbsp;&nbsp;<span class="NewsTips">{{$t("lbl_EMPBE_News") }}</span>
                  </div>
                  <div class="productFiledDesc">
                  {{ $t('lbl_EMPBE_ProductInfo_Customization_desc') }}  
                  </div>
                </div>
                <div class="col-12">
                  <switchIput class="mt-2" ControlId="ProductCustomization" :left="$t('lbl_EMPBE_ProductInfo_Yes')"
                    :right="$t('lbl_EMPBE_ProductInfo_No')" v-model="form.formData.productCustomization">
                  </switchIput>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_DisplayInShowProduct') }}
                  </div>
                </div>
                <div class="col-12">
                  <switchIput class="mt-2" ControlId="isDisplayInShow" :left="$t('lbl_EMPBE_ProductInfo_Yes')"
                    :right="$t('lbl_EMPBE_ProductInfo_No')" v-model="form.formData.isDisplayInShow">
                  </switchIput>
                </div>
              </div> -->

              <!-- <div class="row" v-if="form.formData.isCompanyKFair">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_ProductInfo_IsShowProductKFair2025') }}
                  </div>
                </div>
                <div class="col-12">
                  <switchIput class="mt-2" ControlId="isShowProductKFair" :left="$t('lbl_EMPBE_ProductInfo_Yes')"
                    :right="$t('lbl_EMPBE_ProductInfo_No')" v-model="form.formData.isShowProductKFair">
                  </switchIput>
                </div>
              </div> -->
            </div>
          </div>

        </template>
      </PageValidate>
    </b-overlay>
  </div>

</template>

<script>
import { AlertDialog } from "@/_helpers/AlertDialog";
import { adService } from "../../../_services";
import { productService } from "@/_services/product.service";
import { LogService } from "../../../_services/log.Service";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BasicPageTop from "./BasicPageTop.vue"
export default {
  mixins: [AlertDialog],
  components: {
    BasicPageTop
  },
  props: ["supplierId", "ProductId", "SelectOptions", "permissionData", "PageLeaveType","IsMainProductExceeds","mainProductIds", "submitType"],
  data() {
    return {
      privateProductId: this.ProductId,
      AdPageName: [
        { type: "bannerAd", name: this.$t('lbl_EMPBE_BannerAd')},
        { type: "logoAd", name: this.$t('lbl_EMPBE_LogoAd')},
        { type: "buttonAd", name: this.$t('lbl_EMPBE_ButtonAd')},
        { type: "landingAd", name: this.$t('lbl_EMPBE_LandingPageAd')},
        { type: "videoAd", name: this.$t('lbl_EMPBE_VideoAd')},
        { type: "starAd", name: this.$t('lbl_EMPBE_StarAd')},
        { type: "catListAd", name: this.$t('lbl_EMPBE_CatListAd')},
        { type: "priorityAd", name: this.$t('lbl_EMPBE_priorityAds')},
      ],
      AdCheckItems:[],
      loading: false,
      IsCreated: false,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      form:
      {
        formData: {
          empCompanyId: "",
          productId: "",
          isMainProduct: false,
          premiereDate: '',
          newTech: "",
          isProvideFreeSample: false,
          isDisplayInShow: false,
          isShowProductKFair: false,
          isCompanyKFair: false,
          isShowProductCPS2026:false,
          productCustomization:false,
        },
        tagList: [], 
      },
      disabledDates: {
        from: new Date(),
      },
       originalHotTag:[],
    };
  },
  watch: {
    'form.tagList': {
      async handler(value, oldValue) {
        if(!this.IsCreated&& oldValue.length > value.length){
          var IsDeleteConfirm = await this.CheckHotTagHasAd('keyword',value,oldValue);
          if(IsDeleteConfirm==false)//true 是为可删
          {
            this.form.tagList = oldValue;
          }
        }
      },
      deep: true
    },
    supplierId: {
      handler() {
        this.InitData();
      },
      deep: true,
    },
    form: {
      handler() {
        if (!this.IsCreated) {
          this.$store.state.dirty = true;
        }
      },
      deep: true,
    },
    ProductId: {
      handler(newVal) {
        this.privateProductId = newVal;
      },
    },
  },
  computed: {
    useFormalTables() {
      return String(this.submitType || 'edit').toLowerCase() === 'approval';
    },
    IsShowMainProductErrorTips() {
      return this.form.formData.isMainProduct && !this.mainProductIds.includes(this.reactiveProductId) && this.IsMainProductExceeds 
    },
    companyid() {
      return this.user.empCompanyId;
    },
    GetSearchTagNums() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 3;
        }
      }
      return 1;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    user() {
      return this.$store.state.authentication.user;
    },
    AplusABCBasicBooth() { 
      if (this.permissionData) {
        return ["A+", "A", "B", "C", "Member"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    reactiveProductId() {
      return this.privateProductId && this.privateProductId > 0 ? this.privateProductId : (this.$route.params.id || 0);
    },
  },
  mounted() {
    this.InitData();
  },
  methods: {
    
    async CheckHasAd(type,newVal,oldVal){

        //获取被删的id
        var CheckIds = oldVal.filter(item=>!newVal.includes(item)).map(item=>item+'')
        var PageTypes =  this.AdCheckItems.filter(item=>item.searchType == type && CheckIds.includes(item.searchId+'')).map(item=>item.pageType)
          
        if(PageTypes.length>0)
        {
          var Names = '';
          var AdNames ='';
          var Tips = '';
          AdNames = this.AdPageName.filter(item=>PageTypes.includes(item.type)).map(item=>item.name).join(",")
          if(type==='keyword')
          {
            Names = this.SelectOptions.TagsOptions.filter(item=>CheckIds.includes(item.id+'')).map(item=>item.label).join(",")
            Tips = this.$t('lbl_EMPBE_ProductInfoCheckItems_Tag',{names:Names,adnames:AdNames});
          }
         

            //提示框
            this.showConfirm_Img(
              '',
              Tips,
              this.$t('lbl_EMPBE_Confirm'),
              "",
              "",
              "",
              50,
              50,
              "AlertDialog-Ad-SaveSucess",
              true,
              "",
              "",
              "",
              false,
              false,
              true,
              false
            )
            return true;
        }
        else
        {
          return false;
        }
    },

    // 新提示：
    async CheckHotTagHasAd(type,newVal,oldVal){ 
        const originalData =this.originalHotTag || [];       
        //获取被删的id
        var CheckIds = oldVal.filter(item=>!newVal.includes(item)).map(item=>item+'')
        var hasSaveIdObj = originalData.find(a=>a.toString() == CheckIds.toString());//已保存的id才判断移�?
         
      return new Promise((resolve, reject) => { 
        if(hasSaveIdObj)
        { 
        var PageTypes =  this.AdCheckItems.filter(item=>item.searchType == type && CheckIds.includes(item.searchId+'')).map(item=>item.pageType)
          
        if(PageTypes.length>0)
        {
          var Names = '';
          var AdNames ='';
          var Tips = '';
          AdNames = this.AdPageName.filter(item=>PageTypes.includes(item.type)).map(item=>item.name).join(",")
          if(type==='keyword')
          {
            Names = this.SelectOptions.TagsOptions.filter(item=>CheckIds.includes(item.id+'')).map(item=>item.label).join(",")
            Tips = this.$t('lbl_EMPBE_ProductInfoCheckItems_Tag',{names:Names,adnames:AdNames});
          }
          var lblName=this.SelectOptions.TagsOptions.find(a=>a.id.toString()==CheckIds.toString()).label;
          var lbladName = this.$t('Lbl_Advertisement');
          var adNameTextTips = `<ul class='ItemUL' ><li >${lbladName}: <span style='font-weight: 400; '>${AdNames}</span> </li></ul>`;
          var lblTypeName=this.$t('lbl_EMPBE_ProductHotTag'); 
        
          this.ConfirmCustomHtml(
          this.$t('lbl_EMPBE_DeleteCategory_Title',{CatName:lblName}),
          this.$t('lbl_EMPBE_DeleteCategory_body',{fromType:lblTypeName,AdOrproText:adNameTextTips}),
          this.$t('lbl_EMPBE_Delete'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
          ).then(async (res) => {
                 resolve(res.isConfirmed);
           });
         
        }
        else
        {
           resolve(true);  
        }
        }else{
          resolve(true);  
        }
       });
    },

    async GetAdCheckItem() {
      await adService
        .GetAdCheckItem({ CompId:this.user.empCompanyId ,productId:this.reactiveProductId})
        .then((res) => {
          if (res.isSuccessful) {
            this.AdCheckItems = res.data;
          }
        })
    },
    InitData() {
      this.GetAdCheckItem();
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.$store.state.dirty = false
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated = true;
      // console.log('GetProductTag')
      productService.GetProductTag({ companyId: this.supplierId, ProductId: this.reactiveProductId, useFormalTables: this.useFormalTables }).then(res => {
        if (res.isSuccessful) {
          this.form.formData = res.data.formData ?? this.form.formData;
          this.form.formData.isShowProductKFair = this.form.formData.isShowProductKFair != "true" ? false : true;
          this.form.formData.isShowProductCPS2026 = this.form.formData.isShowProductCPS2026 != "true" ? false : true;
          this.form.formData.isCompanyKFair = this.form.formData.tagIds?.includes('1092');
          this.form.formData.productCustomization = this.form.formData.productCustomization != "true" ? false : true;
          this.form.tagList = res.data.tagList;
          this.originalHotTag=Array.isArray(res.data.tagList)  ? JSON.parse(JSON.stringify(res.data.tagList))  : [];
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
        //this.loading = false;
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      })
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.ProductTags.reset();
    },
    //整理結果提交save
    async AfterSaveResult() {
      const formattedPremiereDate = this.form.formData.premiereDate ? this.$moment(this.form.formData.premiereDate).format("YYYY-MM-DD").toString() : null;
      var data =
      {
        EmpCompanyId: this.supplierId,
        ProductId: this.reactiveProductId ?? 0,
        IsMainProduct: this.form.formData.isMainProduct,
        PremiereDate: formattedPremiereDate,
        NewTech: this.form.formData.newTech,
        IsProvideFreeSample: this.form.formData.isProvideFreeSample,
        IsDisplayInShow: this.form.formData.isDisplayInShow,
        IsShowProductKFair: this.form.formData.isShowProductKFair ?? 'false',
        IsShowProductCPS2026: (this.form.formData.isShowProductCPS2026 === true || this.form.formData.isShowProductCPS2026 === 'true') ? 'true' : 'false',
        ProductCustomization: this.form.formData.productCustomization ?? 'false',
        TagList: this.form.tagList.map((item, index) => {
          return {
            Id: item,
            OrderId: index
          }
        }),
        CertificationsList: [],
        VaildError: [], //验证失败的filed
        validationErrorLog: "" //验证的errorlog
      }
      // console.log("ProductTags AfterSaveResult: ", data);
      return data;

    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        EmpProductId: this.reactiveProductId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "ProductTags",
        Action: action,
      }, errorLogObj);
    },

    //保存
    async Save() {
      var data = await this.AfterSaveResult();
      //写日志
      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Save',
        FormType: 'ProductInfo_Tags',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);
      
      return new Promise((resolve, reject) => {
        productService.SaveProductTag(data).then(res => {
          if (res.isSuccessful) {
            this.privateProductId = res.data;
            this.InitData();
            resolve({ data: res.data, state: true }); //用以确定当前不管作为修改亦或者添加id 都作为data 返回
          } else {
            this.LogPageFormError({ res: res }, 'Save_SaveProductTag');
            reject({
              message: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg.join(",") })
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Save_SaveProductTag');
          reject({
            message: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message })
          });
        })
      });

    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult();

      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Submit',
        FormType: 'ProductInfo_Tags',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        productService.SaveProductTag(data).then(result => {
          if (result.isSuccessful) {
            this.privateProductId = result.data;
            const newProductId = !this.$route.params.id || this.$route.params.id == 0 ? result.data : 0; // For adding new product id when reject

            this.$refs.ProductTags
              .validate(true)
              .then(async (res) => {

                //写日志
                data.VaildError = res.fIldData;
                
                if (res.valid) {
                  this.InitData();
                  resolve({ data: result.data, isAllMandatoryFieldsFilled: true });
                } else {
                  this.GetData();
                  resolve({ data: result.data, isAllMandatoryFieldsFilled: false });
                }
              });
          } else {
            this.LogPageFormError({ result: result }, 'Submit_SaveProductTag');
            reject({
              message: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode",{code:result.statusCode,msg:result.msg?.join(",") || "Error"})
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Submit_SaveProductTag');
          reject({
            message: this.$t("lbl_EMPBE_Submit_Failed_HasError",{ msg: err.message })
          });
        });
      });
    }
  },
};
</script>
<style>
.templateImg {
  height: 150px;
  object-fit: cover;
  object-position: top;
}
</style>
<style scoped>
.errorTips {
  color: red;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.productFiledDesc{
  width: 100%; 
  color: rgba(0, 0, 0, 0.60); 
  font-size: 14px;
   font-weight: 400; 
   line-height: 18.20px; 
   word-wrap: break-word
}
</style>